<template>
  <div>
    <b-modal id="modal-addAccessToken"
             centered
             hide-header
             hide-footer
             size="m">
      <div class="title">
        <h3 class="text-dark font-size-secondary float-left mr-3 mb-5">
          {{ $ml.get('addNewToken')        
        }}
        </h3>
      </div>
      <div class="form"
           :disabled="loading"
           @keyup.enter="onSubmit">
        <b-form-group id="nameGroup"
                      label-for="name">
          <b-form-input class="mb-5"
                        :class="error.name ? 'form-error' : ''"
                        id="name"
                        v-model="form.name"
                        :placeholder="$ml.get('name')"></b-form-input>
        </b-form-group>

        <b-button variant="primary"
                  block
                  :disabled="loading"
                  @click="onSubmit">
          {{ $ml.get('create')   }}
        </b-button>
      </div>
    </b-modal>

    <b-modal id="modal-accessTokenResult"
             centered
             hide-footer
             hide-header
             header-text-variant="light"
             hide-header-close
             body-bg-variant="success"
             body-text-variant="white"
             size="m">
      <b-container>
        <div class="d-flex flex-column">
          <p class="text-white font-size-secondary mb-5 font-weight-bold">
            {{ $ml.get('successful') }}
          </p>
          <p class="mb-5">{{ $ml.get('tokenSuccessResult') }} </p>
          <code class="tokenArea mb-5"
                @click="copyToken"
                ref="textToCopy">{{form.token}}</code>
          <b-button variant="white"
                    class="rounded-sm text-sucess"
                    @click="onCloseCompleteModal()">{{ $ml.get('okey') }}</b-button>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service'

export default {
  name: 'PersonalAccessTokenModal',
  data() {
    return {
      loading: false,
      form: {
        name: '',
        token: '',
      },
      error: {
        name: false,
      },
    }
  },
  methods: {
    doValidation() {
      this.error.name = this.form.name == ''

      return !this.error.name
    },
    onSubmit() {
      if (this.doValidation()) {
        this.loading = true
        ApiService.post(
          `${process.env.VUE_APP_LOGIN_URL}v2/oauth/personal-access-tokens`,
          {
            name: this.form.name,
          }
        )
          .then((res) => {
            this.form.token = res.data.data.access_token
            this.loading = false
            // this.$generateToast(this, 'success', this.$ml.get('successful'))
            this.$bvModal.hide('modal-addAccessToken')
            this.$bvModal.show('modal-accessTokenResult')
            this.$emit('addAccessToken')
            this.form.name = ''
          })
          .catch((err) => {
            this.loading = false

            if (err == 'Error') {
              this.$generateToast(
                this,
                'danger',
                this.$ml.get('anErrorHasOccurred')
              )
            }
          })
      }
    },
    onCloseCompleteModal() {
      this.$bvModal.hide('modal-accessTokenResult')
    },
    copyToken() {
      this.selectText(this.$refs.textToCopy) // e.g. <div ref="text">
      document.execCommand('copy')
      this.$generateToast(this, 'success', this.$ml.get('copied'))
    },
    selectText(element) {
      var range
      if (document.selection) {
        // IE
        range = document.body.createTextRange()
        range.moveToElementText(element)
        range.select()
      } else if (window.getSelection) {
        range = document.createRange()
        range.selectNode(element)
        window.getSelection().removeAllRanges()
        window.getSelection().addRange(range)
      }
    },
  },
}
</script> 

<style lang="scss">
#modal-addAccessToken {
  .form-error {
    border: 1px solid #dc3545;
  }
}
.tokenArea {
  width: 100%;
  padding: 10px;
  text-align: justify;
  cursor: pointer;
}
</style>